import type { GadgetDirectoryItemType } from '@atlassian/jira-dashboard-common/src/types.tsx';

export const matchSearchText = (item: GadgetDirectoryItemType, searchText: string) =>
	item.id.toLowerCase().includes(searchText) ||
	item.titleLabel.toLowerCase().includes(searchText) ||
	item.authorLabel.toLowerCase().includes(searchText) ||
	item.description.toLowerCase().includes(searchText);

export const sortGadget = (gadgets: GadgetDirectoryItemType[]): GadgetDirectoryItemType[] =>
	gadgets.sort((gadget1, gadget2) => {
		const title1 = gadget1.titleLabel?.toLowerCase();
		const title2 = gadget2.titleLabel?.toLowerCase();
		// if undefined, we put them at the bottom
		if (title2 == null) {
			if (title1 != null) {
				return -1;
			}
			return 1;
		}

		if (title1 < title2) {
			return -1;
		}
		if (title1 > title2) {
			return 1;
		}
		return 0;
	});

export const getCategoriesFromGadgetsData = (
	gadgets: GadgetDirectoryItemType[],
	allCategoryLabel: string,
) =>
	gadgets.reduce(
		(accumulator, currentGadget) => {
			currentGadget.categories.forEach((category) => {
				if (accumulator[category]) {
					accumulator[category].push(currentGadget);
				} else {
					accumulator[category] = [currentGadget];
				}
			});
			return accumulator;
		},
		{ [allCategoryLabel]: gadgets },
	);
